<template>
  <div class="mascotte consol masque" :class="{off: !isOpen}">

    <img class="img_mascotte" :src="require(`@/assets/images/mascotte/${mascotteAvatar}`)" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>

    <template v-if="isOpen">
      <component :is="messageLayout" :cta="currentMessage.cta" :class="currentMessage.type" class="side-message right txtleft">
        <div v-html="currentMessage.content"></div>
      </component>
    </template>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import DefaultLayout from './messageLayouts/DefaultLayout'
  import SurveyLayout from './messageLayouts/SurveyLayout'
  import AutoevaluationLayout from './messageLayouts/AutoevaluationLayout'

  export default {
    components: { DefaultLayout, SurveyLayout, AutoevaluationLayout },
    methods: {
      ...mapActions(['clearMessage']),
      clear () {
        this.clearMessage({ messageType: this.currentMessage.type })
      }
    },
    computed: {
      ...mapGetters(['currentMessage']),
      isOpen () {
        return !!this.currentMessage
      },
      mascotteAvatar() {
        if (!this.currentMessage) {
          return 'mascotte-default.png'
        }
        let type = this.currentMessage.type
        if (['notice'].indexOf(type) !== -1) {
          type = 'default' 
        }
        return `mascotte-${type}.png`
      },
      messageLayout() {
        return this.currentMessage.layout + '-layout'
      }
    }
  }
</script>

<style scoped>

  .mascotte.consol {
    display: block;
    width: 100px;
    height: 80px;
    background: #fff;
    top: 230px;
    right: 0;
    border-radius: 50px 0 0 50px;
    position: fixed;
    z-index: 100;
  }
  .mascotte.consol.masque.off {
    right: -400px;
  }
  .mascotte.consol.masque {
    right: 0;
  }
  .mascotte.consol .bubble {
    left: -290px;
    width: 300px;
    font-size: 21px;
    line-height: 25px;
    bottom: 25px;
  }
  .mascotte.consol img {
    max-width: 80px;
    margin-left: 10px;
    margin-top: -20px;
  }

  .mascotte.consol.byebye {
    animation-name: messageoff;
    animation-duration: 0.8s;
    animation-delay: 0.2s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  @keyframes messageoff {
    0% {
      right: -200px; 
    }
    100% {
      right: 0;
    }
  }
  
  .mascotte.consol .bubble.warning  {
    background: #ffae00;
    color: black;
    border-color: #734e00;
	}
.mascotte.consol .bubble.warning.right:before  { border-color: transparent transparent transparent #744f01; }
.mascotte.consol .bubble.warning.right:after { border-color: transparent transparent transparent #ffae00; }

  .mascotte.consol .bubble.error  {
    position: absolute;
	color: #d42919;
	border-color: #d42919;
	}
.mascotte.consol .bubble.error.right:before  {   border-color: transparent transparent transparent #d42919; }
.mascotte.consol .bubble.error.right:after {  top: inherit; background: transparent; padding: 0;  }



</style>
